/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0uDzWjkSs3%7Banimation-direction%3Aalternate%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0nFVCGfONH%7Banimation-duration%3A1.5s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03m2nySHWH%7Banimation-iteration-count%3Ainfinite%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43vdfTHVQb%7Banimation-timing-function%3Alinear%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruGsB2%7Bbackground-color%3Avar(--ds-skeleton%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20k4nwfqi%7B0%25%7Bbackground-color%3Avar(--ds-skeleton-from-color%2Cvar(--ds-skeleton%2C%230515240f))%7Dto%7Bbackground-color%3Avar(--ds-skeleton-to-color%2Cvar(--ds-skeleton-subtle%2C%2317171708))%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1gBibyKB6V%7Banimation-name%3Ak4nwfqi%7D");
import React, { useContext, useEffect, useLayoutEffect as useRealLayoutEffect } from 'react';
import InteractionContext from '@atlaskit/interaction-context';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { BorderRadius } from '@atlaskit/tokens/css-type-schema';
export type SkeletonProps = {
  /**
   * Width of the skeleton.
   */
  width: string | number;
  /**
   * Height of the skeleton.
   */
  height: string | number;
  /**
   * Controls the border radius, or rounding of the skeleton's corners.
   */
  borderRadius?: Exclude<BorderRadius, 'inherit'>;
  /**
   * Overrides the default color of skeleton, and overrides the default shimmering start color if ShimmeringEndColor also provided.
   */
  color?: string;
  /**
   * Overrides the default shimmering ending color of skeleton.
   */
  ShimmeringEndColor?: string;
  /**
   * Enables the shimmering animation.
   */
  isShimmering?: boolean;
  /**
   * Applied as a data-attribute. Use this to target groups of skeletons with the same name (e.g. for applying custom styles)
   * ```
   * groupName="my-skeleton" -> <div data-my-skeleton>
   * ```
   */
  groupName?: string;
  /**
   * An optional `interactionName` used to identify when this component is holding an interaction.
   */
  interactionName?: string;
  /**
   * A test id for automated testing.
   */
  testId?: string;
};
const shimmerKeyframes = null;
const skeletonStyles = null;
const activeShimmerStyles = null;

/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */
const useLayoutEffect = typeof window === 'undefined' ? useEffect : useRealLayoutEffect;

/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */
const Skeleton = ({
  width,
  height,
  borderRadius = "var(--ds-radius-small, 4px)",
  color,
  ShimmeringEndColor,
  isShimmering = false,
  groupName,
  interactionName,
  testId
}: SkeletonProps): JSX.Element => {
  const groupDataAttribute = groupName && `data-${groupName}`;
  const context = useContext(InteractionContext);
  useLayoutEffect(() => {
    if (context != null && fg('platform-dst-skeleton-ufo-hold')) {
      return context.hold(interactionName);
    }
  }, [context, interactionName]);
  return <div data-testid={testId} style={({
    width,
    height,
    borderRadius,
    backgroundColor: color,
    // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
    '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
    '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
  } as React.CSSProperties)} {...groupDataAttribute && {
    [groupDataAttribute]: 'true'
  }} className={ax(["_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2", isShimmering && "", isShimmering && "_1gBibyKB6V"])} />;
};
export default Skeleton;